/* eslint-disable consistent-return */
import PASentry from "util/pa-sentry";

const tryCatchWrapper = (executable) => (...args: any) => {
  try {
    return executable(...args);
  } catch (error) {
    // use any custom handler here
    error.message = `[${executable.name}] - ${error.message}`;
    error.data = { ...error.data, input_args: args };
    console.log("error.message", error.message);
    console.log("error.data", error.data);
    PASentry.logException(error);
  }
};

export default tryCatchWrapper;
